module.exports = __webpack_public_path__ + "static/img/5设计师3.9c43e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/5设计师3.png
// module id = fe17
// module chunks = 1